/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostFilter {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostFilter.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostFilter>): AIUnitEconomicsCostFilter {
        let obj = Object.assign(new AIUnitEconomicsCostFilter(), model);
        AIUnitEconomicsCostFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostFilter>): AIUnitEconomicsCostFilter {
        if (!model) return null;
        return AIUnitEconomicsCostFilter.newInstance(<AIUnitEconomicsCostFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostFilter) {
        if (!obj) return;

        models.AIUnitEconomicsCostFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostFilter): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Start of the usage-date range (inclusive)
     */
    start_date: Date;

    /**
     * End of the usage-date range (exclusive)
     */
    end_date: Date;

    /**
     * Query operator filter; pass a ServiceAccountQueryOperator, ServiceAccountNativeDetailsQueryOperator or TenantQueryOperator to narrow by account, cloud provider or tenant
     */
    filters: models.QueryOperator;

}
